import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaCheck, FaPlug, FaCog, FaTruck, FaCalendar } from 'react-icons/fa';

const Rendezvények: React.FC = () => {
  const services = [
    {
      icon: <FaTruck className="text-3xl text-red-600" />,
      title: "Eszköz bérlés",
      description: "Professzionális elektromos eszközök rendezvényekhez.",
      features: ["Villanyóraszekrények", "Felvonulási szekrények", "Hosszabbítók és ipari kábelek", "Elosztószekrények"]
    },
    {
      icon: <FaCog className="text-3xl text-gray-600" />,
      title: "Teljes körű ügyintézés",
      description: "A tervezéstől a lebonyolításig mindent megoldunk.",
      features: ["Engedélyek beszerzése", "Tervezés és kivitelezés", "Helyszíni felmérés", "Dokumentáció"]
    },
    {
      icon: <FaPlug className="text-3xl text-yellow-500" />,
      title: "Helyszíni szerelés",
      description: "Biztonságos és szakszerű elektromos kiépítés.",
      features: ["Szakszerű kiépítés", "Biztonságos csatlakoztatás", "Próbaüzem", "24/7 ügyeleti szolgálat"]
    }
  ];

  const eventTypes = [
    "Önkormányzati rendezvények",
    "Városi és falunapi események", 
    "Karácsonyi és adventi vásárok",
    "Családi események",
    "Koncertek és fesztiválok",
    "Sportrendezvények",
    "Kiállítások és vásárok",
    "Esküvők és magánrendezvények"
  ];

  const advantages = [
    "Teljes körű elektromos kiszolgálás",
    "Professzionális eszközpark",
    "Gyors telepítés és lebontás",
    "Biztonságos áramellátás",
    "Versenyképes bérleti díjak",
    "Rugalmas időbeosztás",
    "Tapasztalt szakember csapat",
    "Országos kiszállás"
  ];

  const contactDetails = [
    { icon: <FaPhone />, text: 'Nagy Péter Villanyszerelő mester', phone: '+36703620652' },
    { icon: <FaPhone />, text: 'Tamasi Krisztán villamosbiztonsági felülvizsgáló', phone: '+36706049889' },
    { icon: <FaEnvelope />, text: 'kelectrokft@gmail.com', link: 'mailto:kelectrokft@gmail.com' },
    { icon: <FaMapMarkerAlt />, text: 'SZOLNOK és 100km-es körzete' }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-red-600 to-red-800 overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="relative z-10 container mx-auto px-4 h-full flex flex-col justify-center items-center text-center text-white">
          <FaCalendar className="text-6xl mb-6 opacity-80" />
          <h1 className="text-5xl font-bold mb-4">
            Rendezvények Elektromos Kiszolgálása
          </h1>
          <p className="text-xl max-w-3xl leading-relaxed">
            Teljes körű elektromos ellátás minden típusú rendezvényhez - biztonságosan és professzionálisan
          </p>
        </div>
      </section>

      {/* Main Description */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8 text-gray-800">
              Professzionális Rendezvény Elektromos Szolgáltatások
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Legyen szó önkormányzati, városi, falunapi, karácsonyi vagy adventi rendezvényről, 
              akár kisebb családi eseményről is, vállaljuk az esemény teljes körű elektromos ellátását. 
              Célunk, hogy biztonságosan és gördülékenyen biztosítsuk az áramellátást bármilyen eseményhez, 
              hogy Önnek csak az esemény sikerére kelljen figyelnie.
            </p>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">
            Szolgáltatásaink
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {services.map((service, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                <div className="flex justify-center mb-6">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-center text-gray-800">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 text-center">
                  {service.description}
                </p>
                <ul className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center">
                      <FaCheck className="text-green-500 mr-3 flex-shrink-0" />
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Event Types */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">
            Rendezvénytípusok
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
            {eventTypes.map((type, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 text-center">
                <FaCalendar className="text-2xl text-red-600 mx-auto mb-3" />
                <p className="font-medium text-gray-800">{type}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">
            Miért válasszon minket?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {advantages.map((advantage, index) => (
              <div key={index} className="flex items-center space-x-3 bg-gray-50 p-4 rounded-lg hover:bg-red-50 transition-all duration-300">
                <FaCheck className="text-green-500 text-xl flex-shrink-0" />
                <span className="text-gray-700 font-medium">{advantage}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12">
            Kérjen Árajánlatot!
          </h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div>
              <h3 className="text-2xl font-semibold mb-6">Elérhetőségeink</h3>
              <div className="space-y-4">
                {contactDetails.map((item, index) => (
                  <div key={index} className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                      {item.icon}
                    </div>
                    <div>
                      {item.phone ? (
                        <div>
                          <div className="font-medium">{item.text}</div>
                          <a 
                            href={`tel:${item.phone}`}
                            className="text-red-400 hover:text-red-300 font-semibold transition-colors"
                          >
                            {item.phone}
                          </a>
                        </div>
                      ) : item.link ? (
                        <a 
                          href={item.link}
                          className="hover:text-red-400 transition-colors"
                        >
                          {item.text}
                        </a>
                      ) : (
                        <span>{item.text}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-xl">
              <h3 className="text-xl font-semibold mb-4">Gyors kapcsolatfelvétel</h3>
              <p className="text-gray-300 mb-4">
                Hívjon minket bizalommal! Ingyenes helyszíni felméréssel és 
                részletes árajánlattal várjuk megkeresését.
              </p>
              <div className="space-y-2">
                <p className="text-red-400 font-semibold">📞 Azonnali válasz</p>
                <p className="text-red-400 font-semibold">📋 Ingyenes felmérés</p>
                <p className="text-red-400 font-semibold">💰 Versenyképes árak</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Rendezvények;